import Avatar from "common/components/Avatar"
import { useTranslation } from "react-i18next"

const AutovalidationCard = ({
  flexContainer,
  backgroundColor,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <div
      className={`${
        flexContainer ? "tw-flex" : "tw-grid tw-gap-3 tw-grid-cols-[1fr_10fr]"
      } tw-relative before:tw-content-[''] before:tw-absolute before:tw-top-12 before:tw-left-5 before:tw-h-[80%] before:tw-w-1 before:tw-border-r-2 before:tw-border-dotted before:tw-border-[#c1b8b8]
 `}
    >
      <Avatar
        iconName='circle-check'
        backgroundColor={backgroundColor}
      />
      <div
        key={Math.random()}
        className='tw-text-left'
      >
        <p className='tw-text-base tw-mb-0 tw-font-medium tw-text-shadow-default'>
          {t("documentos.validar.idView.autoLabel")}
        </p>
        <p className='tw-text-sm'>
          {t("documentos.validar.idView.valAutoLabel")}
        </p>
      </div>
    </div>
  )
}

export default AutovalidationCard
